import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5afd08e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logotipo" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "language"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "social" }
const _hoisted_7 = ["src", "alt", "title"]

import { ref, withDefaults } from "vue";
import {
  getImage,
  goToLink,
  checkRouter,
  getTranslate,
  setLocale,
} from "@/utils";
import {
  UrlSchema,
  UrlSocialSchema,
  SelectOptions,
} from "@/schemas/common/common";
import { SocialButton } from "@/themes/elements/buttons";


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMenu',
  props: {
    fixed: { type: Boolean, default: true },
    logo: { default: null },
    logoLocal: { type: Boolean, default: true },
    logoAlt: { default: "Logotipo" },
    baseUrl: { default: "#" },
    menu: null,
    menuColor: { default: "#fff" },
    menuColorHover: { default: "#fff" },
    menuFont: { default: "Roboto" },
    menuFontUppercase: { type: Boolean, default: false },
    social: null,
    socialColor: null,
    socialColorHover: null,
    padding: { default: "3rem" },
    height: { default: "4.5rem" },
    background: { default: "#1a1a1a" },
    borderColor: { default: "#fff" },
    languages: null,
    languageDefault: null
  },
  setup(__props: any) {

const props = __props as { fixed: boolean, logo: string | null, logoLocal: boolean, logoAlt: string, baseUrl: string, menu?: UrlSchema[], menuColor: string, menuColorHover: string, menuFont: string, menuFontUppercase: boolean, social?: UrlSocialSchema[], socialColor?: string, socialColorHover?: string, padding: string, height: string, background: string, borderColor: string, languages?: SelectOptions[], languageDefault: string };

_useCssVars(_ctx => ({
  "24e06652": (__props.padding),
  "f2be60be": (__props.height),
  "072e72b0": (__props.background),
  "5953445d": (__props.borderColor),
  "511db6ec": (__props.menuColor),
  "f5660a5c": (__props.menuColorHover)
}))



const language = ref(localStorage.getItem("locale") || props.languageDefault);

const changeLanguage = () => {
  localStorage.setItem("locale", language.value);
  setLocale(language.value);
};

const checkMenuActive = (url: string) => {
  return checkRouter(url) ? "active" : "";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(['header-menu no-select', __props.fixed ? 'fixed' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.logo)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _unref(getImage)(__props.logo, __props.logoLocal),
            alt: __props.logoAlt,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goToLink)(__props.baseUrl)))
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({ menu: true, upper: __props.menuFontUppercase })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menu, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['item', checkMenuActive(item.url)]),
          key: index,
          onClick: ($event: any) => (_unref(goToLink)(item.url, item.url_external))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(__props.menuFont)
          }, _toDisplayString(_unref(getTranslate)(item.label)), 3)
        ], 10, _hoisted_3))
      }), 128))
    ], 2),
    (__props.languages)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((language).value = $event)),
            onChange: _cache[2] || (_cache[2] = ($event: any) => (changeLanguage()))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.languages, (item, index) => {
              return (_openBlock(), _createElementBlock("option", {
                key: index,
                value: item.value,
                class: "option"
              }, _toDisplayString(_unref(getTranslate)(item.label)), 9, _hoisted_5))
            }), 128))
          ], 544), [
            [_vModelSelect, language.value]
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.social, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "item"
        }, [
          _createVNode(_unref(SocialButton), {
            url: item.url,
            background: __props.socialColor,
            "background-hover": __props.socialColorHover,
            onTap: ($event: any) => (_unref(goToLink)(item.url, true))
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _unref(getImage)(item.image?.path, item.image?.local),
                alt: _unref(getTranslate)(item.label),
                title: _unref(getTranslate)(item.title)
              }, null, 8, _hoisted_7)
            ]),
            _: 2
          }, 1032, ["url", "background", "background-hover", "onTap"])
        ]))
      }), 128))
    ])
  ], 2))
}
}

})